import { render, staticRenderFns } from "./MchDetailDiv.vue?vue&type=template&id=c0950852&scoped=true"
import script from "./MchDetailDiv.vue?vue&type=script&lang=js"
export * from "./MchDetailDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0950852",
  null
  
)

export default component.exports